<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_8"></a><a id="page_9"></a>FROM THE ANNALS OF CUAUHTITLAN</h2>
<p class="center2a"><em>In the beginning was the First Sun,<br/>4-Water was its sign;<br/>It was called the Sun of Water.<br/>For water covered the world,<br/>Leaving nothing but the dragonflies above<br/>And the fishy men below</em>.</p>
<p class="center2a"><em>The Second Sun was born,<br/>4-Jaguar was its sign;<br/>This was called the Sun of the Jaguars.<br/>In this Sun the heavens collapsed,<br/>So that the Sun could not move in its course.<br/>The world darkened, and when all was dark<br/>Then the people were devoured</em>.</p>
<p class="center2a"><em>The Giants perished, giving life to the Third Sun.<br/>4-Rain was its sign;<br/>It was called the Sun of Rain.<br/>For this Sun rained fire from bleeding eyes<br/>And the people were consumed</em>.</p>
<p class="center2a"><em>From the torrent of burning stones,<br/>The Fourth Sun was born.<br/>4-Wind was its sign, and it was called the Sun of Wind.<br/>In this Sun, all which stood on the earth was carried<br/>Away by terrible winds.<br/>The people were turned into monkeys,<br/>And scattered from their cities into the forest</em>.</p>
<p class="center2a"><em>Now, by sacrifice of the divine liquid, the Fifth Sun was born.<br/>Its sign was 4-Motion.<br/>As the Sun moved, following a course,<br/>The ancients called it the Sun of Motion.<br/>In the time of this Sun, there were<br/>Great earthquakes and famine,<br/>No maize grew, and the gods of the field<br/><a id="page_10"></a>Turned their eyes from the people.<br/>And all the people grew thin, and perished</em>.</p>
<p class="center2a"><em>The Lord of Heaven cut the heart from his living son,<br/>And so was born the Sixth Sun, which sustains<br/>The universe with infinite light.<br/>Its sign was 4-Flint.<br/>Those who watch the sky say this Sun<br/>Will end in annihilation, when the flint-knife<br/>Severs the birthcord of the Sun, plunging all<br/>Into darkness, where the people will<br/>Be cut to pieces and scattered</em>.</p>
<p class="center2a"><em>This is the time of the Sixth Sun. . . .</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter004.vue?9d843898